import React, { useState } from 'react';

import { StyledImage } from './PlayImage.styles';

const Image = ({
    src,
    width,
    height,
    inView,
    ssr,
    sizes,
    srcSet,
    alt,
    blurred,
    showPlaceholder,
    opacity,
}) => {
    const [error, setError] = useState(false);

    return (
        <StyledImage
            as={error || !inView ? 'div' : 'img'}
            key={src}
            width={width}
            onError={() => setError(true)}
            height={height}
            data-src={src}
            src={src}
            srcSet={srcSet}
            sizes={sizes}
            ssr={ssr}
            alt={alt}
            inView={inView}
            blurred={blurred}
            showPlaceholderImage={showPlaceholder}
            opacity={opacity}
        />
    );
};

export default Image;
